import { GETWORKSPACEOWNERS_SUCCESS, GETWORKSPACEOWNERS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getWorkSpaceOwnersReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETWORKSPACEOWNERS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETWORKSPACEOWNERS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getWorkSpaceOwnersReducer;
